import styled from 'styled-components'

import { Color } from 'constants/color'

export const Container = styled.div`
    position: relative;
    background: ${Color.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4em;
    height: 2.5em;
    cursor: pointer;
    color: ${Color.white};
    border-radius: 3.5em;

    /* handheld devices (ipads, phones, 992px and down) */
    @media only screen and (max-width: 992px) {
        display: none;
    }
`

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const NoteIcon = styled.img`
    width: 1.5em;
    height: 1.5em;
`

export const BadgeCount = styled.span`
    font-weight: bold;
    margin-left: 4px;
    display: inline-block;
`
